import { Button } from '@mui/material'
import React from 'react'

interface LeadDocumentsProps {
    leadID: any
}

export const LeadDocuments = ({ leadID }: LeadDocumentsProps) => {
    return (
        <div className="flex flex-col gap-2 text-center">
            <div>Передавайте данные CRM в отдельный документ, сгенерированный на основе вашего файла</div>
            <div className="mt-4">
                <Button variant="contained" color="primary">Сформировать документ</Button>
            </div>
        </div>
    )
}
